export enum TrackingPagename {
  Motorization = 'select_motorization',
  Summary = 'your_vehicle',
  VehicleLength = 'select_vehicle_length',
  OnlineCodeOverview = 'online_code_overview',
  TransferMotorizationModal = 'transfer_configuration_layer',
  ErrorPage = 'error',
  Preconfig = 'pre_configuration_page'
}
